module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "task-details-make-container"
  }, [_c('task-details-header', {
    on: {
      "taskStatusId": _vm.getTaskStatusId,
      "allowOperate": _vm.setAllowOperate,
      "viewStatusId": _vm.getViewStatusId,
      "taskEvaluation": _vm.getTaskEvaluation
    }
  }), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('comb.taskAnchor')
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.anchorLoading),
      expression: "anchorLoading",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "anchor-info-container"
  }, [(_vm.anchor.anchorId) ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.anchor.anchorPic || 'http://fdfs.test.ximalaya.com/group1/M00/3C/26/wKgDplhk3i2ADxL_AAA3c-AGB9M155.jpg',
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info-right"
  }, [_c('div', [_c('p', {
    staticClass: "anchor-name"
  }, [_c('a', {
    attrs: {
      "href": ((_vm.$store.state.XMLY_INDEX_URL) + "zhubo/" + (_vm.anchor.anchorId)),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.anchor.anchorName))]), _c('i', {
    staticClass: "icon icon-vip",
    class: _vm.vipIconClass,
    staticStyle: {
      "margin-right": "15px"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('word.fans')) + "：" + _vm._s(_vm._f("formatNumber")(_vm.anchor.fansCount)))])]), _vm._v(" "), _c('p', {
    staticClass: "anchor-num"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('comb.personalIntro')) + "：")]), _c('span', {
    staticClass: "oneLine"
  }, [_vm._v(_vm._s(_vm.anchor.personalSignature))])]), _vm._v(" "), _c('p', {
    staticClass: "anchor-num"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('comb.contractTime')) + "：")]), _c('span', [_vm._v(_vm._s(_vm.anchor.contractTime))])])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "operate"
  })])])]) : _vm._e()])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('comb.albumManagement')
    }
  }, [_c('div', {
    staticClass: "album-management"
  }, [_c('div', {
    staticClass: "album-info-wrapper"
  }, [_c('div', {
    staticClass: "image-wrapper"
  }, [_c('img', {
    attrs: {
      "src": ("" + _vm.UPLOAD_IMG_HOST + (_vm.albumForm.coverPath))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "album-info"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("专辑名称：")]), (_vm.albumForm.albumStatus === 1) ? _c('a', {
    attrs: {
      "href": _vm.getAlbumUrl,
      "target": "_blank"
    }
  }, [_vm._v("《" + _vm._s(_vm.albumForm.title) + "》")]) : _c('span', [_vm._v("《" + _vm._s(_vm.albumForm.title) + "》")])]), _vm._v(" "), (_vm.albumForm.paid) ? _c('span', {
    key: "albumForm.albumId"
  }, [_vm._v("专辑售价：" + _vm._s(_vm.albumForm.price))]) : _c('span', {
    key: "albumForm.albumId"
  }, [_vm._v("免费专辑")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.albumForm.paid),
      expression: "albumForm.paid"
    }]
  }, [_vm._v("折扣价格：" + _vm._s(_vm.albumForm.discountPrice))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.albumForm.paid),
      expression: "albumForm.paid"
    }]
  }, [_vm._v("免费集数：" + _vm._s(_vm.albumForm.freeEpisode))])])]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.albumForm.paid && _vm.allowOperate && _vm.albumForm.albumStatus === 1),
      expression: "albumForm.paid && allowOperate && albumForm.albumStatus === 1"
    }],
    staticClass: "on-sale-button",
    class: {
      'on-sale-button-middle': !_vm.albumForm.isOnSale
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.albumDialog = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.albumForm.isOnSale ? '专辑调价' : _vm.$t('comb.albumOnSale')))])], 1)])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.voiceLoading),
      expression: "voiceLoading",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "voice-works-list"
  }, [_vm._l((_vm.taskWorksList), function(item, index) {
    return _c('div', {
      staticClass: "works-item",
      attrs: {
        "sound_id": item.taskWorkId,
        "sound_src": ("" + _vm.UPLOAD_IMG_HOST + (item.defaultUrl)),
        "sound_duration": item.duration,
        "sound_playusage": "2"
      }
    }, [_c('div', {
      staticClass: "works-item-index"
    }, [_vm._v(_vm._s(_vm.totalVoiceCount - (_vm.pageSize * (_vm.currentPage - 1)) - index))]), _vm._v(" "), _c('div', {
      staticClass: "works-item-content"
    }, [_c('div', [_c('div', {
      staticClass: "download-wrapper"
    }, [_c('p', {
      staticClass: "works-name"
    }, [_vm._v(_vm._s(item.fileName))]), _vm._v(" "), _c('a', {
      attrs: {
        "href": ("/api/requirement/" + (item.requirementId) + "/task/work/" + (item.taskWorkId) + "/download"),
        "download": ""
      }
    }, [_vm._v("下载音频")])]), _vm._v(" "), _c('div', {
      staticClass: "xm-player"
    }, [_c('i', {
      staticClass: "player_btn"
    }), _vm._v(" "), _c('div', {
      staticClass: "player_progressbar"
    }, [_c('div', {
      staticClass: "player_seekbar"
    }), _vm._v(" "), _c('div', {
      staticClass: "player_playbar"
    }), _vm._v(" "), _c('div', {
      staticClass: "player_wavebox",
      attrs: {
        "sound_wave": ("" + _vm.UPLOAD_IMG_HOST + (item.waveForm)),
        "sound_uploadid": ("u_" + (item.fileId))
      }
    })]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "player_position"
    }, [_vm._v("00:00")]), _vm._v(" /\n                            "), _c('span', {
      staticClass: "player_duration"
    }, [_vm._v(_vm._s(_vm._f("format-audio-time")(item.duration)))])])])]), _vm._v(" "), _c('div', {
      staticClass: "status-date-wrapper"
    }, [_c('span', {
      staticClass: "status-label"
    }, [_vm._v(_vm._s(item.statusLabel))]), _vm._v(" "), _c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm.formatDate(item.createTime)))])])])])
  }), _vm._v(" "), (_vm.totalPage >= 2) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-count": _vm.totalPage,
      "layout": "prev, pager, next"
    },
    on: {
      "current-change": _vm.changePage
    }
  })], 1) : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.multiWarmTips,
      "lock-scroll": false,
      "size": "small"
    },
    on: {
      "close": _vm.closeDialog
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "rate-item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('comb.recordQuality')))]), _vm._v(" "), _c('el-rate', {
    attrs: {
      "disabled": _vm.rateDisabled,
      "colors": ['#99A9BF', '#F7BA2A', '#fc5832']
    },
    on: {
      "change": _vm.changeRecordQualityScore
    },
    model: {
      value: (_vm.recordQualityScore),
      callback: function($$v) {
        _vm.recordQualityScore = $$v
      },
      expression: "recordQualityScore"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "rate-item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('comb.serviceAttitude')))]), _vm._v(" "), _c('el-rate', {
    attrs: {
      "disabled": _vm.rateDisabled,
      "colors": ['#99A9BF', '#F7BA2A', '#fc5832']
    },
    on: {
      "change": _vm.changeAttitudeScore
    },
    model: {
      value: (_vm.attitudeScore),
      callback: function($$v) {
        _vm.attitudeScore = $$v
      },
      expression: "attitudeScore"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "rate-item"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('comb.responseSpeed')))]), _vm._v(" "), _c('el-rate', {
    attrs: {
      "disabled": _vm.rateDisabled,
      "colors": ['#99A9BF', '#F7BA2A', '#fc5832']
    },
    on: {
      "change": _vm.changeSpeedScore
    },
    model: {
      value: (_vm.speedScore),
      callback: function($$v) {
        _vm.speedScore = $$v
      },
      expression: "speedScore"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "evaluate-content"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('comb.taskEvaluate')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taskEvaluation),
      expression: "taskEvaluation"
    }],
    attrs: {
      "readonly": _vm.rateDisabled,
      "placeholder": _vm.multiEvaluateContentMissing
    },
    domProps: {
      "value": (_vm.taskEvaluation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.taskEvaluation = $event.target.value
      }
    }
  })]), _vm._v(" "), (!_vm.rateDisabled) ? _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.closeRate
    }
  }, [_vm._v(_vm._s(_vm.$t('word.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.submitEvaluateBtnStatus,
      "disabled": _vm.submitEvaluateBtnStatus,
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.submitEvaluate
    }
  }, [_vm._v(_vm._s(_vm.$t('word.ok')))])], 1) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "lock-scroll": false,
      "size": "small",
      "title": _vm.multiBreakRecord
    },
    model: {
      value: (_vm.breakDialog),
      callback: function($$v) {
        _vm.breakDialog = $$v
      },
      expression: "breakDialog"
    }
  }, [_vm._l((_vm.monthBreachCount), function(item) {
    return _c('div', {
      staticClass: "break-item"
    }, [_c('span', [_vm._v(_vm._s(item.month))]), _c('span', [_vm._v(_vm._s(_vm.$t('word.uploadBreak')) + _vm._s(item.count) + _vm._s(_vm.$t('word.times')))])])
  }), _vm._v(" "), (_vm.monthBreachCount.length === 0) ? _c('div', [_vm._v(_vm._s(_vm.$t('sen.noBreakRecord')))]) : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('comb.albumPricing'),
      "size": "small"
    },
    model: {
      value: (_vm.albumDialog),
      callback: function($$v) {
        _vm.albumDialog = $$v
      },
      expression: "albumDialog"
    }
  }, [_c('el-form', {
    ref: "albumForm",
    attrs: {
      "model": _vm.albumForm,
      "label-width": "80px",
      "label-position": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('comb.voicePrice')
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls": false,
      "min": 0,
      "size": "small"
    },
    model: {
      value: (_vm.albumForm.price),
      callback: function($$v) {
        _vm.albumForm.price = $$v
      },
      expression: "albumForm.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('comb.voiceDiscountPrice')
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls": false,
      "min": 0,
      "size": "small"
    },
    model: {
      value: (_vm.albumForm.discountPrice),
      callback: function($$v) {
        _vm.albumForm.discountPrice = $$v
      },
      expression: "albumForm.discountPrice"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('comb.freeEpisode')
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": _vm.albumForm.isOnSale,
      "controls": false,
      "min": 0,
      "size": "small"
    },
    model: {
      value: (_vm.albumForm.freeEpisode),
      callback: function($$v) {
        _vm.albumForm.freeEpisode = $$v
      },
      expression: "albumForm.freeEpisode"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "order-buttons"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.commitAlbum($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('word.ok')))]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.albumDialog = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('word.cancel')))])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0537fe3e!./~/vue-loader/lib/selector.js?type=template&index=0!./views/copyrighter/taskManagement/TaskDetailsMaking.vue
// module id = 1087
// module chunks = 0